export default "__VITE_ASSET__COEEFJ3B__"